import React from 'react';
import { MapPinIcon, PencilIcon, TrashIcon } from '../../Icons';

interface MapControlButtonsProps {
  interactionMode: 'none' | 'draw' | 'select';
  hasInteracted: boolean;
  hasSpatialFilter: boolean;
  onToggleMode: (mode: 'draw' | 'select') => void;
  onClearSpatialFilter: () => void;
}

export const MapControlButtons: React.FC<MapControlButtonsProps> = ({
  interactionMode,
  hasInteracted,
  hasSpatialFilter,
  onToggleMode,
  onClearSpatialFilter,
}) => {
  return (
    <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-[1001] flex items-center justify-center gap-2.5 w-max max-w-[95vw] pointer-events-none">
      {/* Botón Punto Exacto */}
      <button
        onClick={() => onToggleMode('select')}
        className={`px-4 py-2.5 rounded-xl shadow-xl pointer-events-auto transition-all transform active:scale-95 flex items-center gap-2 group relative border ${
          interactionMode === 'select'
            ? 'bg-[#00234F] text-white border-[#001c3f] font-extrabold ring-4 ring-blue-50'
            : 'bg-white text-gray-800 border-gray-200 font-bold hover:bg-gray-50 shadow-md'
        }`}
        title="Punto Exacto"
      >
        <MapPinIcon className={`w-4 h-4 ${interactionMode === 'select' ? 'animate-pulse text-sky-400' : 'text-[#00234F]'}`} />
        <span className="text-[11px] font-black uppercase tracking-wider">
          {interactionMode === 'select' ? 'Buscando...' : 'Punto Exacto'}
        </span>
      </button>

      {/* Botón Dibujar Polígono */}
      <div className="relative pointer-events-auto">
        <button
          onClick={() => onToggleMode('draw')}
          className={`px-4 py-2.5 rounded-xl shadow-xl transition-all transform active:scale-95 flex items-center gap-2 group border ${
            interactionMode === 'draw'
              ? 'bg-sky-600 text-white border-sky-450 font-extrabold ring-4 ring-sky-100'
              : 'bg-white text-sky-700 border-sky-100 font-bold hover:bg-sky-50 shadow-md'
          }`}
          title="Dibujar polígono"
        >
          <PencilIcon className={`w-4 h-4 ${interactionMode === 'draw' ? 'animate-pulse' : ''}`} />
          <span className="text-[11px] font-black uppercase tracking-wider">
            {interactionMode === 'draw' ? 'Dibujando...' : 'Dibujar'}
          </span>
        </button>

        {!hasInteracted && (
          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 pointer-events-none z-[100]">
            <div className="bg-sky-600 text-white text-[10px] font-black uppercase tracking-wider px-3.5 py-1.5 rounded-lg shadow-xl animate-bounce whitespace-nowrap flex items-center gap-1.5 border border-sky-400 relative">
              <span>✍🏼 ¡Dibuja en el mapa para filtrar!</span>
              <div className="absolute top-full left-1/2 -translate-x-1/2 border-x-4 border-x-transparent border-t-4 border-t-sky-600"></div>
            </div>
          </div>
        )}
      </div>

      {/* Botón Limpiar Filtro Espacial */}
      {hasSpatialFilter && (
        <button
          onClick={onClearSpatialFilter}
          className="px-4 py-2.5 bg-red-600 text-white rounded-xl shadow-xl hover:bg-red-700 pointer-events-auto transition-transform active:scale-95 flex items-center gap-1.5 border border-red-500 font-bold shadow-md"
          title="Limpiar filtro espacial"
        >
          <TrashIcon className="w-4 h-4" />
          <span className="text-[11px] font-black uppercase tracking-wider">Limpiar</span>
        </button>
      )}
    </div>
  );
};
